import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';

export const usePublishProject = () => {
  const [fetch, response] = useRequest<{
    project_fund_matches_with_additional_questions: number[];
  }>();

  const publishProject = useCallback(
    (projectId: number) => {
      return fetch(API.paths.project_confirm(projectId), 'patch', {
        data: null,
      });
    },
    [fetch],
  );

  return [publishProject, response] as const;
};
